import * as Sentry from '@sentry/react';

import { TThunk } from '../index';
import { updateUser, resetUser } from '../slices/user';
import { fetchAuthToken, removeAuthToken } from '../../api/tokens';

export const getUser = (): TThunk => async (dispatch, getState, api) => {
  try {
    const token = fetchAuthToken();

    if (!token) {
      dispatch(resetUser());
      return;
    }

    const payload = await api.user.getUser();

    if (payload) {
      const {
        data: {
          id,
          attributes: {
            email,
            name,
            firstName,
            lastName,
            autoGenerated,
          },
        },
        included: [{ attributes: { avatar }}],
        meta: { autoLogin }
      } = payload;

      const user = {
        id,
        email,
        name,
        firstName,
        lastName,
        avatar,
        autoGenerated,
        autoLogin,
      };

      dispatch(updateUser(user));
      Sentry.setUser({ id, email });
    } else {
      removeAuthToken();
      dispatch(resetUser());
    }
  } catch (e) {
    removeAuthToken();
    dispatch(resetUser());
  }
};
